export class RwStopAddOns {
    podPhoto?: boolean;
    podSig?: boolean;
    podBar?: boolean;
    itemToDeliver?: string;
    addOnsId?: string;
    stopId?: string;
}
